import React, { useEffect, useState, useContext, useRef } from "react";
import "./Home_Partners.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

// Import Swiper Styles
import "swiper/css";
import "swiper/css/navigation";
import Common_Title from "../../../common_components/common_title/Common_Title";

const Home_Partners = () => {
  const { getData, imageUrl } = useContext(Context);
  const [ourPartner, setOurPartner] = useState([]);

  // Navigation References
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const getBlogs = async () => {
    try {
      const res = await getData("/without-login/master/all-our-partners");
      if (res?.success) {
        setOurPartner(res.data);
      }
    } catch (error) {
      console.error("Error fetching partner company logos:", error);
    }
  };

  useEffect(() => {
    getBlogs();
  }, []);

  const partnerList = ourPartner || [];

  return (
    <section className="home-partners-section">
        <div className="container">

      <div className="partners-container">
        {/* Centered Heading */}

        <Common_Title title="Featured " subTitle={" Companies"} />

        {/* Relative Wrapper for Slider + Absolute Side Arrows */}
        <div className="slider-relative-wrapper">
          {/* Custom Left Arrow */}
          <button ref={prevRef} className="nav-arrow prev-arrow">
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          {partnerList.length > 0 && (
            <Swiper
              className="banner_partners_slider"
              modules={[Autoplay, Navigation]}
              spaceBetween={10}
              loop={true}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 3 },
                480: { slidesPerView: 4 },
                768: { slidesPerView: 6 },
                1024: { slidesPerView: 8 },
                1200: { slidesPerView: 9 },
              }}
            >
              {partnerList.map((value, index) => (
                <SwiperSlide key={value.id || index}>
                  <div className="logo-card">
                    <img
                      src={`${imageUrl}${value?.image}`}
                      alt={value?.name || "Featured Company"}
                      className="company-logo"
                      onError={(e) => {
                        e.target.style.opacity = "0.3";
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          {/* Custom Right Arrow */}
          <button ref={nextRef} className="nav-arrow next-arrow">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
        </div>
    </section>
  );
};

export default Home_Partners;
